module.exports = __webpack_public_path__ + "img/1520842766.a7d0103f.jpg";